import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-address-field-prepend',
  templateUrl: './address-field-prepend.component.html',
  imports: [
    ReactiveFormsModule
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldPrependComponent implements OnInit {
  @Input() fieldControl: FormControl;

  constructor() {
  }

  ngOnInit(): void {
  }

}
